(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const productTabsBlocks = document.querySelectorAll('.product-tabs-block');

    productTabsBlocks.forEach((tabsBlock) => {
      const tabs = tabsBlock.querySelectorAll('.product-tabs__tab');
      const contentWrapper = tabsBlock.querySelector('.product-tabs__content-wrapper');
      const templates = tabsBlock.querySelectorAll('template[data-tab-template]');
      const templateByIndex = new Map(Array.from(templates, (template) => [template.dataset.tabTemplate, template]));

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          const clickedTab = e.currentTarget;
          const tabIndex = clickedTab.dataset.tabIndex;
          const template = templateByIndex.get(tabIndex);

          if (!template || clickedTab.classList.contains('product-tabs__tab--active') || !contentWrapper) return;

          const nextContent = template.content.firstElementChild?.cloneNode(true);
          if (!nextContent) return;

          tabs.forEach((t) => t.classList.remove('product-tabs__tab--active'));
          clickedTab.classList.add('product-tabs__tab--active');
          contentWrapper.replaceChildren(nextContent);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
